/* import __COLOCATED_TEMPLATE__ from './fallback-editor.hbs.js'; */
var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { next } from '@ember/runloop';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { ref } from 'ember-ref-bucket';
let FallbackEditor = (_dec = ref('fallbackInput'), _class = class FallbackEditor extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "fallbackInput", _descriptor2, this);
  }
  get composer() {
    return this.args.composer;
  }
  get node() {
    let selection = this.composer.state.prosemirrorState.selection;
    return selection?.node;
  }
  get isVisible() {
    let templateNodeSpec = this.composer.state.prosemirrorState.schema.nodes.template;
    return templateNodeSpec && this.node?.type === templateNodeSpec && this.attributeInfoResolver?.isValid(this.attributePath);
  }
  get fallback() {
    return this.node.attrs.fallback;
  }
  get showFallbackEditor() {
    return this.attributeInfoResolver?.isFallbackAllowed(this.attributePath);
  }
  get attributePath() {
    return this.node.attrs.attributePath;
  }
  get attributeInfoResolver() {
    return this.composer.config.templating?.resolver;
  }
  get fallbackPlaceholderText() {
    return this.intl.t('prosemirror.components.tools.fallback-editor.placeholder-text', {
      thing: this.attributeInfoResolver?.humanReadable(this.attributePath)?.toLowerCase()
    });
  }
  get fallbackInfoText() {
    return this.attributeInfoResolver?.fallbackInfoText(this.attributePath);
  }
  focusIfEmpty(element) {
    if (isEmpty(this.fallback)) {
      next(this, () => {
        element.focus();
      });
    }
  }
  onKeyUp(e) {
    this.update();
    if (e.key === 'Enter') {
      this.composer.commands.setSelectionToEnd();
    }
  }
  update() {
    if (this.fallbackInput && this.fallbackInput.value !== this.fallback) {
      this.composer.commands.updateSelectedNode({
        fallback: this.fallbackInput.value
      });
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "fallbackInput", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "focusIfEmpty", [action], Object.getOwnPropertyDescriptor(_class.prototype, "focusIfEmpty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onKeyUp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onKeyUp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "update", [action], Object.getOwnPropertyDescriptor(_class.prototype, "update"), _class.prototype), _class);
export { FallbackEditor as default };